import React from 'react';
import styled from 'styled-components';

import { Button, Grid } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const StyledGrid = styled(Grid)`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const ProductImage = styled.img`
	width: 300px;
	height: 300px;
	object-fit: contain;
`;

const ErrorMessage = styled.span`
	color: '#d32f2f';
	fontfamily: 'Roboto', 'Helvetica', 'Arial', 'sans-serif';
	margin: '10px 0 0 0';
`;

const ImageUploadForm = ({ productImage, error, handleImageChange }) => {
	return (
		<StyledGrid item md={5} xs={12}>
			<ProductImage
				src={productImage}
				width={'300px'}
				height={'300px'}
				alt="Gift design"
				loading="lazy"
			/>
			<input
				accept="image/*"
				//   className={classes.input}
				style={{ display: 'none' }}
				multiple
				type="file"
				id="raised-button-file"
				onChange={handleImageChange}
			/>
			<label htmlFor="raised-button-file" style={{ margin: '10px 0 0 0' }}>
				<Button
					variant="outlined"
					component="span"
					size="medium"
					startIcon={<UploadFileIcon />}
				>
					Upload Image
				</Button>
			</label>
			{error && <ErrorMessage>{error}</ErrorMessage>}
		</StyledGrid>
	);
};

export default ImageUploadForm;
